import apiRes from '../core/apiRes'

const Home = () =>
  import(/* webpackChunkName: "application" */ './home/Home.vue')
const Dashboard = () =>
  import(/* webpackChunkName: "application" */ './dashboard/Dashboard.vue')
const Users = () =>
  import(/* webpackChunkName: "application" */ './users/Users.vue')
const Company = () =>
  import(/* webpackChunkName: "application" */ './company/Company.vue')
const Invoices = () =>
  import(/* webpackChunkName: "application" */ './invoices/Invoices.vue')
const Payments = () =>
  import(/* webpackChunkName: "application" */ './payments/Payments.vue')
const PaymentsLog = () =>
  import(/* webpackChunkName: "application" */ './paymentsLog/PaymentsLog.vue')
const PayoutSettings = () =>
  import(/* webpackChunkName: "application" */ './payoutSettings/PayoutSettings.vue')
const IdCheckInfo = () =>
  import(/* webpackChunkName: "application" */ './idcheck/Info.vue')
const IdcheckClients = () =>
  import(/* webpackChunkName: "application" */ './idcheck/Clients.vue')
const IdcheckRequests = () =>
  import(/* webpackChunkName: "application" */ './idcheck/Requests.vue')
const IdcheckRequestsInfo = () =>
  import(/* webpackChunkName: "application" */ './idcheck/RequestsInfo.vue')
const IdcheckTemplates = () =>
  import(/* webpackChunkName: "application" */ './idcheck/Templates.vue')

const QrCodes = () =>
  import(/* webpackChunkName: "application" */ './qr/QrList.vue')

const QrReports = () =>
  import(/* webpackChunkName: "application" */ './reports/QrReports.vue')
const BankReports = () =>
  import(/* webpackChunkName: "application" */ './reports/BankReports.vue')
const SubTransactionsReports = () =>
  import(/* webpackChunkName: "application" */ './reports/SubTransactionsReports.vue')
const Products = () =>
  import(/* webpackChunkName: "application" */ './products/ProductTable.vue')
const Errors = () => import(/* webpackChunkName: "application" */ './company/Errors.vue')

const dashboard = {
  path: '/',
  name: 'dashboard',
  component: Dashboard,
  meta: { title: 'dashboard' }
}
const users = {
  path: 'users',
  name: 'users',
  component: Users,
  meta: { title: 'users' }
}
const company = {
  path: 'company',
  name: 'company',
  component: Company,
  meta: { title: 'company' }
}
const payments = {
  path: 'payments',
  name: 'payments',
  component: Payments,
  meta: { title: 'payments' }
}
const paymentsLog = {
  path: 'payments-log',
  name: 'payments-log',
  component: PaymentsLog,
  meta: { title: 'payments_log' }
}
const payoutSettings = {
  path: 'payout-settings',
  name: 'payout-settings',
  component: PayoutSettings,
  meta: { title: 'payouts' }
}
const invoices = {
  path: 'invoices',
  name: 'invoices',
  component: Invoices,
  meta: { title: 'invoices' }
}

const idcheckClients = {
  path: 'idcheckClients',
  name: 'idcheckClients',
  component: IdcheckClients,
  meta: { title: 'idcheckClients' }
}

const idcheckRequests = {
  path: 'idcheckRequests',
  name: 'idcheckRequests',
  component: IdcheckRequests,
  meta: { title: 'idcheckRequests' }
}

const idcheckRequestsInfo = {
  path: 'idcheckRequestsInfo',
  name: 'idcheckRequestsInfo',
  component: IdcheckRequestsInfo,
  meta: { title: 'idcheckRequestsInfo' }
}

const idcheckTemplates = {
  path: 'idcheckTemplates',
  name: 'idcheckTemplates',
  component: IdcheckTemplates,
  meta: { title: 'idcheckTemplates' }
}

const idcheckInfo = {
  path: 'idcheckInfo',
  name: 'idcheckInfo',
  component: IdCheckInfo,
  meta: { title: 'idcheckInfo' }
}

const qrCodes = {
  path: 'qrCodes',
  name: 'qrCodes',
  component: QrCodes,
  meta: { title: 'qrCodes' }
}

const qrReports = {
  path: 'qrReports',
  name: 'qrReports',
  component: QrReports,
  meta: { title: 'qrReports' }
}

const bankReports = {
  path: 'bankReports',
  name: 'bankReports',
  component: BankReports,
  meta: { title: 'bankReports' }
}

const reportErip = {
  meta: { title: 'reportErip' }
}

const reportInternetAcquiring = {
  meta: { title: 'reportInternetAcquiring' }
}

const subTransactionsReports = {
  path: 'subTransactionsReports',
  name: 'subTransactionsReports',
  component: SubTransactionsReports,
  meta: { title: 'subTransactionsReports' }
}

const products = {
  path: 'products',
  name: 'products',
  component: Products,
  meta: { title: 'products' }
}

const errors = {
  path: 'errors',
  name: 'errors',
  component: Errors,
  meta: { title: 'errorDecoding' }
}

const errorsTitle = {
  meta: { title: 'errors' }
}

const home = {
  path: '/',
  name: 'home',
  component: Home,
  children: [
    dashboard,
    users,
    company,
    payoutSettings,
    payments,
    paymentsLog,
    invoices,
    idcheckClients,
    idcheckRequests,
    idcheckRequestsInfo,
    idcheckInfo,
    idcheckTemplates,
    qrCodes,
    qrReports,
    bankReports,
    subTransactionsReports,
    products,
    errors
  ]
}

export const appRoutes = home

export const appMenu = [
  {
    text: invoices.meta.title,
    route: invoices.name,
    check: () => !!apiRes.invoicesUrl
  },
  {
    text: products.meta.title,
    route: products.name,
    check: () => !!apiRes.productsUrl
  },
  {
    text: 'qrCodes',
    check: () => !!apiRes.qrUrl,
    childs: [
      {
        text: 'list',
        route: qrCodes.name
      }
    ]
  },
  {
    text: payments.meta.title,
    route: payments.name,
    check: () => !!apiRes.paymentsUrl
  },
  {
    text: paymentsLog.meta.title,
    route: paymentsLog.name,
    check: () => !!apiRes.paymentsLogUrl
  },
  {
    text: 'idcheck',
    check: () =>
      !!apiRes.idcheckClients ||
      !!apiRes.idcheckRequests ||
      !!apiRes.idcheckRequestsInfo ||
      !!apiRes.idcheckInfo ||
      !!apiRes.idcheckTemplates,
    childs: [
      {
        text: idcheckClients.meta.title,
        route: idcheckClients.name,
        check: () => !!apiRes.idcheckClients
      },
      {
        text: idcheckTemplates.meta.title,
        route: idcheckTemplates.name,
        check: () => !!apiRes.idcheckTemplates
      },
      {
        text: idcheckRequests.meta.title,
        route: idcheckRequests.name,
        check: () => !!apiRes.idcheckRequests
      },
      {
        text: idcheckRequestsInfo.meta.title,
        route: idcheckRequestsInfo.name,
        check: () => !!apiRes.idcheckRequestsInfo
      }
      // {
      //   text: idcheckInfo.meta.title,
      //   route: idcheckInfo.name,
      //   check: () => !!apiRes.idcheckInfo
      // }
    ]
  },
  {
    text: errorsTitle.meta.title,
    route: errors.name,
    check: () => !!apiRes.errorsUrl
  },
  {
    text: 'reports',
    check: () => (!!apiRes.qrReportParams && !!apiRes.qrReports) || (!!apiRes.bankReports) || (!!apiRes.subTransactionsReports),
    childs: [
      {
        text: reportErip.meta.title,
        action: 'reports'
      },
      {
        text: reportInternetAcquiring.meta.title,
        action: 'reports'
      },
      {
        check: () => !!apiRes.bankReports,
        text: bankReports.meta.title,
        route: bankReports.name
      },
      {
        check: () => !!apiRes.subTransactionsReports,
        text: subTransactionsReports.meta.title,
        route: subTransactionsReports.name
      },
      {
        check: () => !!apiRes.qrReportParams && !!apiRes.qrReports,
        text: qrReports.meta.title,
        route: qrReports.name
      }
    ]
  },
  {
    text: 'settings',
    check: () => !!apiRes.profileUrl && !!apiRes.usersUrl,
    childs: [
      {
        text: company.meta.title,
        route: company.name,
        check: () => !!apiRes.profileUrl
      },
      {
        text: users.meta.title,
        route: users.name,
        check: () => !!apiRes.usersUrl
      },
      {
        text: payoutSettings.meta.title,
        route: payoutSettings.name,
        check: () => !!apiRes.payoutSettings
      }
    ]
  }
]
